import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.webhooks')
  .factory('$webhooks', webhooksObjectFactory);

/* @ngInject */
function webhooksObjectFactory($bringozFactory: $bringozFactory,
                               WebhooksAPI: BringozApi,
                               Webhooks_DS: DataStoreConfig,
                               Webhooks_PN: PushNotificationsConfig) {
  function $webhooks(id: string) {
    return $bringozFactory(id, WebhooksAPI, Webhooks_DS, Webhooks_PN)
  }

  return $webhooks;
}
